import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { KioskService } from '@services/kiosk.service';

@Component({
  selector: 'gc-timeout-dialog',
  templateUrl: './timeout-dialog.component.html',
  styleUrls: ['./timeout-dialog.component.scss'],
  standalone: false,
})
export class TimeoutDialogComponent implements OnInit, OnDestroy {
  timeout: ReturnType<typeof setTimeout>;
  interval: ReturnType<typeof setInterval>;
  maxTimeout = 30000; //30 seconds
  public time = this.maxTimeout / 1000;

  constructor(
    public dialogRef: MatDialogRef<TimeoutDialogComponent>,
    public readonly kioskService: KioskService,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    this.timeout = setTimeout(() => {
      this.returnHome();
    }, this.maxTimeout);

    // sets the count down timer on the screen
    this.interval = setInterval(() => this.time--, 1000);
  }

  closeDialog() {
    clearTimeout(this.timeout);
    clearInterval(this.interval);
    this.dialogRef.close('close');
  }

  returnHome() {
    this.router.navigate(['kiosk', this.kioskService.uuid]);
    clearTimeout(this.timeout);
    clearInterval(this.interval);
    this.dialogRef.close('home');
  }

  ngOnDestroy(): void {
    this.dialogRef = null;
    clearTimeout(this.timeout);
    clearInterval(this.interval);
  }
}
